// @flow
import { call, put, takeEvery, select } from 'redux-saga/effects'
import { HOLIDAYS_LIST } from '../actionTypes'
import { holidaysList, setPending } from '../actions'
import { showError } from '../../toastr/utils'
import { getViewOrganizationSettingsId } from '../../organizations/selectors'
import { getOrgHolidaysPending } from '../selectors'
import makeAPIRequest from 'store/entities/api/sagas'
import { getPostOrganizationHolidaysList } from 'app/constants/api/orgHolidays'

export default function* getSaga(): Generator<*, *, *> {
  yield takeEvery(HOLIDAYS_LIST.GET.REQUEST, handleGetRequest)
}

export function* handleGetRequest(): Generator<*, *, *> {
  try {
    const pending = yield select(getOrgHolidaysPending)
    const orgId = yield select(getViewOrganizationSettingsId)
    if (!pending) {
      yield put(setPending(true))
      const {
        data: { data: holidays },
      } = yield call(makeAPIRequest, getPostOrganizationHolidaysList(orgId), {
        method: 'GET',
      })
      yield put(
        holidaysList.get.success({
          holidays,
          orgId,
        })
      )
    }
  } catch (error) {
    console.error('orgHolidaysList handleGetRequest saga failed', error)
    yield put(holidaysList.get.fail(error))
    showError()
  } finally {
    yield put(setPending(false))
  }
}
